import { SimpleChipsInput } from '@mi-front/ui';
import { Box } from '@mui/material';
import { useFormikContext } from 'formik';
import { useIntl } from 'react-intl';
import { GipReportValues } from '../../types';
import { LoadOrderParamsFromOrdersField } from './LoadOrderParamsFromOrdersField';

export const OrdersField = () => {
  const { $t } = useIntl();
  const { values, setFieldValue, isSubmitting } = useFormikContext<GipReportValues>();

  return (
    <>
      <Box mb={1}>
        <SimpleChipsInput
          value={values.orders}
          label={$t({
            id: 'audit.gipReport.form.orders',
            defaultMessage: 'Órdenes',
          })}
          placeholder={$t({
            id: 'audit.gipReport.form.allOrders',
            defaultMessage: 'Todas las órdenes',
          })}
          onChange={(_event, value) => setFieldValue('orders', value)}
          readOnly={isSubmitting}
        />
      </Box>
      <LoadOrderParamsFromOrdersField />
    </>
  );
};
